import React, { useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../Loader/TicketLoader";
import { FaPencilAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { useClientList } from "../../hooks/useClientList";
import { formatDateTime } from "../../utils/dateutils";

function Ticket({ handleoldtickets }) {
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [ticketform, setticketform] = useState({
    name: "",
    contact: "",
    description: "",
    file: null,
    title: "",
  });
  const [isEditing, setIsEditing] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  const fileInputRef = useRef(null);
  const location = useLocation();

  const { clientlist } = useClientList(userDetails);

  const selectedClient = (clientlist || []).find(
    (client) => Number(client.id) === Number(userDetails?.clientid)
  );

  const Approvalstatus =
    selectedClient?.tic_approval?.approval_cmanager === true ||
    selectedClient?.tic_approval?.approval_bh === true;

  const handleticket = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const DateAndTime = formatDateTime(new Date());
    const status = Approvalstatus ? "Approval Pending" : "Un Assigned";
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/ticket.php`;
    const formData = new FormData();
    formData.append("subs", userDetails?.sub);

    formData.append("user_id", userDetails?.id);
    formData.append("name", userDetails?.username);
    formData.append(
      "contact_number",
      ticketform?.contact || userDetails?.phone
    );
    formData.append("e_des", ticketform?.description);
    formData.append("files", ticketform.file);
    formData.append("title", ticketform.title);
    formData.append("status", status);

    if (status === "Un Assigned") {
      formData.append("unassignedTime", DateAndTime);
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        handleoldtickets();
        setticketform({
          name: "",
          contact: "",
          description: "",
          file: null,
          title: "",
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        toast.success(
          `Ticket Created Successfully!\nTicket Number: ${data.ticket_number}`
        );
      } else {
        alert(`Error: ${data.message || "An unexpected error occurred."}`);
      }
    } catch (error) {
      console.error("Error during ticket submission:", error);
      alert(`Error: ${error.message}`);
    } finally {
      setIsLoading(false); // hide loader
    }
  };

  return (
    <div>
      <div className="tra1">
        {location.pathname !== "/CM" && (
          <h2 className="retick">Raise a Ticket!</h2>
        )}
        <motion.div
          className={location.pathname !== "/CM" ? "form-container" : null}
          initial={{ height: "auto", opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          {isLoading && <Loader />}

          <form onSubmit={handleticket}>
            <div className="row">
              <div className="form-group">
                <label>Username</label>
                <div>
                  <div>{userDetails?.username}</div>
                </div>
              </div>

              <div className="form-group">
                <label>Email</label>
                <div>
                  <div>{userDetails?.email}</div>
                </div>
              </div>

              <div className="form-group">
                <label>Contact Number</label>
                {!isEditing ? (
                  <>
                    <div className="in">
                      <div className="input-lock">
                        <div>
                          <div>{userDetails?.phone}</div>
                        </div>
                        <div>
                          <button onClick={() => setIsEditing(true)}>
                            <FaPencilAlt />
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="input-block">
                      <input
                        className="input"
                        value={ticketform?.contact}
                        onChange={(e) =>
                          setticketform((prev) => ({
                            ...prev,
                            contact: e.target.value,
                          }))
                        }
                        type="tel"
                        pattern="[0-9]{10}"
                        required
                      />
                    </div>
                  </>
                )}
                {errors.contactNumber && (
                  <span className="error">{errors.contactNumber}</span>
                )}
              </div>
            </div>

            <div className="column">
              <div className="form-group">
                <label>Error Title</label>

                <input
                  className="input"
                  value={ticketform?.title}
                  onChange={(e) =>
                    setticketform((prev) => ({
                      ...prev,
                      title: e.target.value,
                    }))
                  }
                  type="text"
                  required
                />
              </div>

              <div className="form-group">
                <label>Error Description</label>
                <textarea
                  className="textarea"
                  value={ticketform?.description}
                  onChange={(e) =>
                    setticketform((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                  type="text"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>File</label>
              <input
                className="input"
                // value={ticketform?.file}
                ref={fileInputRef}
                onChange={(e) =>
                  setticketform((prev) => ({
                    ...prev,
                    file: e.target.files[0],
                  }))
                }
                type="file"
              />
            </div>

            <div className="form-group">
              <button className="sebtn" type="submit">
                Submit
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
}

export default Ticket;
